module.exports = __webpack_public_path__ + "static/media/PAKI9396b.d313e952.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/images/climb/PAKI9396b.JPG
// module id = 166
// module chunks = 0